<template>
    <tbody :class="$style['mds-tbody']">
        <slot />
    </tbody>
</template>

<script>
    export default {
        name: 'MdsTbody',
    };
</script>

<style lang="scss" module>
    @use './tbody.scss';
</style>
